import { connect } from "react-redux";
import ProgressTracker from "./ProgressTracker"
import { fetchAllUsers, updateUserAssignmentProgress } from "../../../../redux/actions/user_actions"


const mapStateToProps = (state, props) => {
    return ({
        users: Object.values(state.users),
        currentUserId: state.session.user.id,
        currentUser: state.session.user.username,
        currentUserRole: state.session.user.role,
        gridlabel: props.gridlabel
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        fetchAllUsers: () => dispatch(fetchAllUsers()),
        updateUserAssignmentProgress: (payload) => dispatch(updateUserAssignmentProgress(payload))
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressTracker);